import { render, staticRenderFns } from "./NoteCardContainer.vue?vue&type=template&id=560720a6&scoped=true"
import script from "./NoteCardContainer.vue?vue&type=script&lang=js"
export * from "./NoteCardContainer.vue?vue&type=script&lang=js"
import style0 from "./NoteCardContainer.vue?vue&type=style&index=0&id=560720a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560720a6",
  null
  
)

export default component.exports